import { BaseModel } from 'app/core/_base/crud';
export class ChonDeNghiTamUngModel extends BaseModel {
        Id: number
        DeNghiTamUng_SoPhieu: string
        NoiDung: string
        SoTien: string
        DeNghiTamUng_NgayDeNghi: string
        DeNghiTamUng_HanThanhToan: string
        isSelected:boolean
        clear() {
                this.Id = 0;
                this.DeNghiTamUng_SoPhieu = '';
                this.NoiDung = '';
                this.SoTien = '';
                this.DeNghiTamUng_NgayDeNghi = '';
                this.DeNghiTamUng_HanThanhToan = '';
                this.isSelected=false;
        }
        copy(item: ChonDeNghiTamUngModel) {
                this.Id = item.Id;
                this.DeNghiTamUng_SoPhieu = item.DeNghiTamUng_SoPhieu;
                this.NoiDung = item.NoiDung;
                this.SoTien = item.SoTien;
                this.DeNghiTamUng_NgayDeNghi = item.DeNghiTamUng_NgayDeNghi;
                this.DeNghiTamUng_HanThanhToan = item.DeNghiTamUng_HanThanhToan;
                this.isSelected=item.isSelected;
        }
}
